import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// material-ui
import { Button } from "@mui/material";

import { getSportCourtTypes } from "services/sportCourtTypeServices";
import AddSportCategoryDialog from "./_addSportCourtTypeDialog";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import TableComponent from "components/TopCourtComponents/Table/TableComponent";

export default function SportCategoryComponent({
    merchantId, placeId
}) {
    const [isLoading, setLoading] = useState(true)

    const [rows, setRows] = useState([]);
    const [dialog, setDialog] = useState({
        open: false,
        data: null,
    });

    const loadData = async () => {
        try {
            let { data, error } = await getSportCourtTypes(
                merchantId, placeId
            );
            if (error) throw error;
            if (data) {
                setRows(data);
                setLoading(false)
            }
        } catch (error) {
            console.log(error);
            setLoading(false)
        }
    }

    useEffect(() => {
        loadData();
    }, []);

    const valueCustomator = (row) => {
        return ({
            name: <TCLabel>{row.sportTypeId?.name ?? '-'}</TCLabel>,
            courtType: <TCLabel>{row.courtTypeId?.name ?? '-'}</TCLabel>,
        })
    }
    
    return (
        <>
        <Button variant="contained" color="primary" sx={{mb: 2}} onClick={() => {
            setDialog({ open: true });
        }}>Add Sport Category</Button>
        <TableComponent
            columns={[
                { label: "Sport Category" },
                { label: "Court Type" },
            ]}
            rows={rows}
            valueCustomator={valueCustomator}
            loading={isLoading}
        />
        <AddSportCategoryDialog merchantId={merchantId} placeId={placeId} setDialog={dialog} handleClose={() => {
            setDialog({
                open: false,
                data: null,
            });
            loadData();
        }}/>
        </>
    );
}
